import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

@Component({
	selector: 'app-list-filters-panel',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './list-filters-panel.component.html',
	styleUrl: './list-filters-panel.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFiltersPanelComponent {
	readonly title = input<string>('Filtros')
	readonly searchLabel = input<string>('Buscar')
	readonly clearLabel = input<string>('Limpiar filtros')
	readonly searchDisabled = input<boolean>(false)
	readonly clearDisabled = input<boolean>(false)

	readonly searchClicked = output<void>()
	readonly clearClicked = output<void>()
}
